export function openOfficeDialog(
  url: string,
  options?: { height?: number; width?: number }
): Promise<string> {
  return new Promise((resolve, reject) => {
    Office.context.ui.displayDialogAsync(
      url,
      { height: options?.height ?? 60, width: options?.width ?? 30 },
      (result) => {
        if (result.status === Office.AsyncResultStatus.Failed) {
          reject(new Error(result.error.message));
          return;
        }

        const dialog = result.value;

        dialog.addEventHandler(
          Office.EventType.DialogMessageReceived,
          (args) => {
            if ("message" in args) {
              dialog.close();
              resolve(args.message);
            }
          }
        );

        dialog.addEventHandler(
          Office.EventType.DialogEventReceived,
          (args) => {
            if ("error" in args) {
              dialog.close();
              reject(new Error(`Dialog closed with error code: ${args.error}`));
            }
          }
        );
      }
    );
  });
}
